/**
 * TAMWAJ — تصحيح اتجاه الكاروسيل في RTL
 *
 * Flickity لا يقرأ dir="rtl" من الصفحة، فيحسب إزاحة الشريط من اليسار
 * ثم يطبّقها فوق تخطيط يبدأ من اليمين — فتخرج البطاقات خارج الشاشة.
 * (بطاقة واحدة في «مختارات تموّج» كانت تقف عند x=1538 داخل شاشة 1440.)
 *
 * rightToLeft خيار موثّق في Flickity؛ ضبطه على defaults يشمل كل
 * كاروسيلات القالب: مختارات تموّج، المنتجات المقترحة، شوهد مؤخرًا،
 * معرض صور المنتج، والسلايدشو.
 *
 * يُحمَّل بـ defer بين libs.min.js و theme.min.js — وسكربتات defer
 * تُنفَّذ بترتيب ورودها، فيضبط الخيار قبل إنشاء أي كاروسيل.
 */
(function () {
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;
  if (typeof window.Flickity !== 'function' || !window.Flickity.defaults) return;

  window.Flickity.defaults.rightToLeft = true;
})();
